
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M8.005-1.849c-4.113 0-5.315.005-5.549.024-.844.07-1.37.203-1.941.488a3.943 3.943 0 00-1.132.828c-.625.65-1.004 1.447-1.141 2.396-.067.46-.086.555-.09 2.907v3.201c0 4.11.005 5.31.024 5.544.068.821.197 1.338.47 1.903a4.15 4.15 0 002.69 2.197c.405.105.854.162 1.43.19.244.01 2.73.018 5.218.018s4.976-.003 5.213-.016c.667-.03 1.054-.083 1.482-.193a4.125 4.125 0 002.69-2.202c.267-.551.403-1.088.464-1.866.013-.17.019-2.876.019-5.577 0-2.703-.006-5.403-.02-5.573-.062-.791-.197-1.323-.473-1.885a3.907 3.907 0 00-.843-1.155c-.652-.623-1.449-1.001-2.399-1.138-.46-.067-.552-.087-2.906-.09H8.005z","fill":"#6772E5"}}),_c('path',{attrs:{"d":"M8.194 5.908c-.501 0-.803.132-.803.474 0 .985 3.6.52 3.609 3.139C11 11.094 9.649 12 7.683 12c-.812 0-1.7-.15-2.58-.501V9.407c.795.404 1.796.703 2.58.703.53 0 .908-.132.908-.536C8.59 8.527 5 8.914 5 6.488 5 4.932 6.276 4 8.194 4c.784 0 1.559.114 2.343.404V6.47a5.585 5.585 0 00-2.343-.562z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"16","height":"16","rx":"8","fill":"#fff"}})])])])
          )
        }
      }
    